
import MainLayout from "@/components/layout/MainLayout";
import { FileStorage } from "@/components/storage/FileStorage";

const FolderManagement = () => {
  return (
    <MainLayout>
      <FileStorage />
    </MainLayout>
  );
};

export default FolderManagement;
